// extracted by mini-css-extract-plugin
var _1 = "J5ft5";
export { _1 as "skipToMainContentLink" }
